var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftShowAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 20C15.6895 20 20.1667 15.5227 20.1667 10C20.1667 4.47727 15.6895 0 10.1667 0C4.64401 0 0.166748 4.47727 0.166748 10C0.166748 15.5227 4.64401 20 10.1667 20ZM10.1667 1.66668C14.769 1.66668 18.5001 5.39773 18.5001 10C18.5001 14.6023 14.769 18.3333 10.1667 18.3333C5.56448 18.3333 1.83343 14.6023 1.83343 10C1.83343 5.39773 5.56448 1.66668 10.1667 1.66668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2442 14.7559C11.5696 15.0814 12.0972 15.0814 12.4227 14.7559C12.7481 14.4305 12.7481 13.9028 12.4227 13.5774L8.84525 9.99999L12.4227 6.42257C12.7481 6.09715 12.7481 5.56949 12.4227 5.24406C12.0972 4.91863 11.5696 4.91863 11.2442 5.24406L7.07748 9.41074C6.75205 9.73617 6.75205 10.2638 7.07748 10.5893L11.2442 14.7559Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.166748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftShowAccount);
export default __webpack_public_path__ + "static/media/arrow-left-show-account.79bacdb77c4df6a7eb8cabb42372b20e.svg";
export { ForwardRef as ReactComponent };